<template>
    <div class="grey--text text--darken-2" style="display:flex" oldClass="{'text-align-right': field.align == 'right'}" >
        <div style="flex-grow:1">
            <div>{{field.title}}</div>
            <v-progress-circular v-if="uploading" indeterminate color="grey"></v-progress-circular>
            <div v-for="(file, fileIndex) in record[field.name]" :key="fileIndex">
                <a :href="file.url" target="_blank">
                {{fileNameFromStoragePath(file.url)}}
                </a>&nbsp;
                <v-icon small color="grey lighten-1" xxstyle="float:right" @click="deleteFileFromGroup(file)">cancel</v-icon>
            </div>
        </div>
        <div>
            <UploadWrapper @click="doNothing" @select="uploadFiles">
                <v-btn :color="field.color" :disabled="field.disabled">{{field.title}}</v-btn>
            </UploadWrapper>
        </div>
    </div>  
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import UploadWrapper from '../ui-elements/UploadWrapper'
import FileHelpers from '../helpers/FileHelpers'



export default {
    data() {
        return {
            uploading: false,
        }
    },

    components: {
        UploadWrapper,
    },
    
    props: {
        field: Object,
        record: Object,
    },

    computed: {

    },

    methods: {

        doNothing() {
            this.$set(this.field, 'disabled', true)
            setTimeout( () => {
                this.$set(this.field, 'disabled', false)
            }, 1000)
        },

        uploadFiles(files) {
            this.uploading = true
            FileHelpers.filesToFirebase(files, 'fieldUploads').then(fileGroup => {
                let newArrayValue = [...(this.record[this.field.name] || []), ...fileGroup]
                this.$set(this.record, this.field.name, newArrayValue)
                this.uploading = false
            })
        },
        fileNameFromStoragePath(path) {
            return FileHelpers.fileNameFromStoragePath(path)
        },
        deleteFileFromGroup(file) {

            FileHelpers.deleteFirebaseFile(file.url)
            let idx = this.record[this.field.name].findIndex(o => o.url == file.url)
            this.record[this.field.name].splice(idx,1)
        },
    },

    created() {

    },

    // watch: {
    //     item: {
    //         handler: function (val, oldVal) { /* ... */ },
    //         deep: true
    //     },
    // }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// FileField.vue?e1144ab2